import React, { forwardRef } from 'react';
import styles from './DetailRow.module.css';

export interface IDetailRowProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onCopy'> {
  label: string;
  value: string | React.ReactNode;
  layout?: 'vertical' | 'horizontal';
  copyable?: boolean;
  onCopy?: () => void;
  highlight?: boolean;
}

const DetailRow = forwardRef<HTMLDivElement, IDetailRowProps>(
  (
    {
      label,
      value,
      layout = 'horizontal',
      copyable = false,
      onCopy,
      highlight = false,
      className,
      ...rest
    },
    ref,
  ) => {
    return (
      <div ref={ref} className={`${styles.row} ${styles[layout]} ${className || ''}`} {...rest}>
        <span className={`${styles.label} ${highlight ? styles.highlight : ''}`}>{label}</span>
        {layout === 'vertical' ? (
          <div className={styles.valueContainer}>
            <span className={styles.valueText}>{value}</span>
            {copyable && onCopy && (
              <button className={styles.copyButton} onClick={onCopy} aria-label={`Copy ${label}`}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                </svg>
              </button>
            )}
          </div>
        ) : (
          <span className={`${styles.value} ${highlight ? styles.highlight : ''}`}>{value}</span>
        )}
      </div>
    );
  },
);

DetailRow.displayName = 'DetailRow';

export default DetailRow;
